import { RemoteGetAllProfessionals } from 'data/usecases/professionals';
import { GetAllProfessionalsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfessionals } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllProfessionals =
  (): GetAllProfessionalsUseCaseInterface =>
    new RemoteGetAllProfessionals(
      makeApiUrlProfessionals(),
      makeAxiosHttpClient(),
    );
